import gql from "graphql-tag"

export const DELETE_QLIRO_ONE_CONFIG = gql`
  mutation deleteQliroOneConfig($id: ID!) {
    deleteQliroOneConfig(id: $id) {
      status
    }
  }
`
